import React from "react";
import { isCurrentRowTheFooter } from "../utils";
import { language } from "language/default";
export const GroupingColumnCellRenderer = (params) => {
    if (params.valueFormatted) {
        return params.valueFormatted;
    }
    if (isCurrentRowTheFooter(params.node) && params.context.displayTotals) {
        return React.createElement(React.Fragment, null, language.en.common.total);
    }
    return params.value ? params.value : React.createElement(React.Fragment, null);
};
